import { RoomDetails } from "../types";

// export const handleRoomAllocation = (
//   adultsCount: number,
//   childrenCount: number,
//   infantCount: number,
//   seniorsCount: number,
//   numberOfRoomCount: number
// ): RoomDetails[] => {
//   const MAX_CAPACITY_PER_ROOM = 4;
//   const roomDetails: RoomDetails[] = [];
//   adultsCount = typeof adultsCount === "number" && adultsCount >= 0 ? adultsCount : 1;
//   childrenCount = typeof childrenCount === "number" && childrenCount >= 0 ? childrenCount : 0;
//   infantCount = typeof infantCount === "number" && infantCount >= 0 ? infantCount : 0;
//   seniorsCount = typeof seniorsCount === "number" && seniorsCount >= 0 ? seniorsCount : 0;
//   numberOfRoomCount = typeof numberOfRoomCount === "number" && numberOfRoomCount >= 1 ? numberOfRoomCount : 1;
//   adultsCount = adultsCount + seniorsCount;
//   childrenCount = childrenCount + infantCount;
//   infantCount = 0;
//   seniorsCount = 0;

//   let remainingAdults = adultsCount;
//   let remainingChildren = childrenCount;

//   // Check for over-allocation in a single room
//   if (numberOfRoomCount === 1 && adultsCount > MAX_CAPACITY_PER_ROOM) {
//     console.error("Too many guests for a single room!");
//     return [];
//   }

//   // Case: Single room allocation, all must fit in one room
//   if (numberOfRoomCount === 1) {
//     if (adultsCount <= MAX_CAPACITY_PER_ROOM) {
//       roomDetails.push({
//         roomNo: 1,
//         adults: adultsCount,
//         seniors: 0,
//         child: Math.min(childrenCount, MAX_CAPACITY_PER_ROOM - adultsCount),
//         infant: 0,
//         childAges: "",
//       });
//       return roomDetails;
//     } else {
//       console.error("Too many guests for a single room!");
//       return [];
//     }
//   }

//   // Ensure at least 1 adult per room
//   if (adultsCount < numberOfRoomCount) {
//     remainingAdults = numberOfRoomCount;
//   }

//   // Step 1: Pre-fill each room with at least 1 adult
//   for (let i = 0; i < numberOfRoomCount; i++) {
//     const room: RoomDetails = {
//       roomNo: i + 1,
//       adults: 0,
//       seniors: 0,
//       child: 0,
//       infant: 0,
//       childAges: "",
//     };

//     if (remainingAdults > 0) {
//       room.adults = 1;
//       remainingAdults--;
//     }

//     roomDetails.push(room);
//   }

//   // Step 2: Evenly distribute remaining adults while respecting max capacity
//   let roomIndex = 0;
//   while (remainingAdults > 0) {
//     let room = roomDetails[roomIndex];
//     let totalGuests = room.adults + room.child;

//     if (totalGuests < MAX_CAPACITY_PER_ROOM) {
//       room.adults++;
//       remainingAdults--;
//     }

//     roomIndex = (roomIndex + 1) % numberOfRoomCount;

//     // Prevent infinite loops if no valid placements are possible
//     if (roomIndex === 0 && remainingAdults > 0) {
//       let canPlace = roomDetails.some((room) => room.adults + room.child < MAX_CAPACITY_PER_ROOM);
//       if (!canPlace) {
//         console.error("Too many adults for the available rooms.");
//         return [];
//       }
//     }
//   }

//   // Step 3: Evenly distribute children while respecting max capacity
//   roomIndex = 0;
//   while (remainingChildren > 0) {
//     let room = roomDetails[roomIndex];
//     let totalGuests = room.adults + room.child;

//     if (totalGuests < MAX_CAPACITY_PER_ROOM) {
//       room.child++;
//       remainingChildren--;
//     }

//     roomIndex = (roomIndex + 1) % numberOfRoomCount;

//     // Prevent infinite loops
//     if (roomIndex === 0 && remainingChildren > 0) {
//       let canPlace = roomDetails.some((room) => room.adults + room.child < MAX_CAPACITY_PER_ROOM);
//       if (!canPlace) {
//         console.error("Too many children for the available rooms.");
//         return [];
//       }
//     }
//   }
//   return roomDetails;
// };

export const handleRoomAllocation = (
  adultsCount: number,
  childrenCount: number,
  infantCount: number,
  seniorsCount: number,
  numberOfRoomCount: number,
  childrenAges?: number[] | string | null
): RoomDetails[] => {
  const MAX_CAPACITY_PER_ROOM = 4;
  const roomDetails: RoomDetails[] = [];

  // Validate inputs
  adultsCount = typeof adultsCount === "number" && adultsCount >= 0 ? adultsCount : 1;
  childrenCount = typeof childrenCount === "number" && childrenCount >= 0 ? childrenCount : 0;
  infantCount = typeof infantCount === "number" && infantCount >= 0 ? infantCount : 0;
  seniorsCount = typeof seniorsCount === "number" && seniorsCount >= 0 ? seniorsCount : 0;
  numberOfRoomCount = typeof numberOfRoomCount === "number" && numberOfRoomCount >= 1 ? numberOfRoomCount : 1;

  // Normalize childrenAges into a queue of numeric ages we'll consume as we
  // place children. Accepts an array (e.g. [7, 11]) or a comma-separated
  // string ("7,11"). Anything malformed is dropped silently — the function
  // still returns a valid room layout, just without ages on that slot.
  let agesQueue: number[] = [];
  if (Array.isArray(childrenAges)) {
    agesQueue = childrenAges
      .map((a) => (typeof a === "number" ? a : parseInt(String(a), 10)))
      .filter((a) => Number.isFinite(a) && a >= 0 && a <= 17);
  } else if (typeof childrenAges === "string" && childrenAges.length > 0) {
    agesQueue = childrenAges
      .split(",")
      .map((a) => parseInt(a.trim(), 10))
      .filter((a) => Number.isFinite(a) && a >= 0 && a <= 17);
  }

  // Combine adults and seniors; children + infants count together
  adultsCount = adultsCount + seniorsCount;
  childrenCount = childrenCount + infantCount;

  // Calculate total guests
  const totalGuests = adultsCount + childrenCount;

  // If total guests exceed current room capacity, increase room count
  const requiredRooms = Math.ceil(totalGuests / MAX_CAPACITY_PER_ROOM);
  if (requiredRooms > numberOfRoomCount) {
    numberOfRoomCount = requiredRooms;
  }

  let remainingAdults = adultsCount;
  let remainingChildren = childrenCount;

  // Ensure at least 1 adult per room
  if (remainingAdults < numberOfRoomCount) {
    remainingAdults = numberOfRoomCount;
  }

  // Step 1: Pre-fill rooms with 1 adult each
  for (let i = 0; i < numberOfRoomCount; i++) {
    const room: RoomDetails = {
      roomNo: i + 1,
      adults: 0,
      seniors: 0,
      child: 0,
      infant: 0,
      childAges: "",
    };

    if (remainingAdults > 0) {
      room.adults = 1;
      remainingAdults--;
    }

    roomDetails.push(room);
  }

  // Step 2: Fill remaining adults
  let roomIndex = 0;
  while (remainingAdults > 0) {
    let room = roomDetails[roomIndex];
    let totalGuests = room.adults + room.child;
    if (totalGuests < MAX_CAPACITY_PER_ROOM) {
      room.adults++;
      remainingAdults--;
    }
    roomIndex = (roomIndex + 1) % numberOfRoomCount;
  }

  // Step 3: Fill children + assign ages in the same order they were listed.
  // childAges is a comma-separated string per the existing room contract.
  roomIndex = 0;
  while (remainingChildren > 0) {
    let room = roomDetails[roomIndex];
    let totalGuests = room.adults + room.child;
    if (totalGuests < MAX_CAPACITY_PER_ROOM) {
      room.child++;
      remainingChildren--;
      const age = agesQueue.shift();
      if (age !== undefined) {
        room.childAges = room.childAges ? `${room.childAges},${age}` : `${age}`;
      }
    }
    roomIndex = (roomIndex + 1) % numberOfRoomCount;
  }

  return roomDetails;
};
